import React, { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { Title } from '@/ui'
import { userSelectors } from '@/entity/user'
import { employerProfileSelectors, employerProfileThunks } from '@features/employerProfile/model'
import { UploadImagePlaceholder } from '@app/images/index'
import { ProfileActions } from './ProfileActions'
import { InformationAboutCompany, CompanyAccountData, EmployerInformation } from '@/features'
import styles from './EmployerProfile.module.scss'
import { removeItemByKeyPartial } from '@/shared'
import { actions as administrationActions } from '@/entity/administration/actions'

export const EmployerProfile = () => {
	const dispatch = useDispatch()
	const companies = useSelector(userSelectors.employerCompanies)
	const activeCompany = useSelector(employerProfileSelectors.activeCompany)
	const employer = useSelector(userSelectors.user)
	const { t } = useTranslation()

	const onChangeCompany = useCallback(
		(id) => {
			removeItemByKeyPartial('activeStaffBranch')
			dispatch(administrationActions.getStaffingAdminOrgsActionReset())
			id && dispatch(employerProfileThunks.getCompany({ id }))
		},
		[dispatch]
	)
	// const [enableModal, setEnableModal] = useState()
	// useMemo(() => setEnableModal(process.env.REACT_APP_MODAL_INFO_EMPLOYER), [])
	// const [isOpenInfoEmployer, setIsOpenInfoEmployer] = useState(false)
	// const isCheck = getFromLocalStorage('isCheck_01')
	// useEffect(() => {
	// 	if (!isCheck && enableModal === '1') {
	// 		setIsOpenInfoEmployer(true)
	// 	} else {
	// 		setIsOpenInfoEmployer(false)
	// 	}
	// }, [enableModal])

	return (
		<>
			{/*{isOpenInfoEmployer && (*/}
			{/*	<NotificationEmployer*/}
			{/*		handleProcess={setIsOpenInfoEmployer.bind(null, false)}*/}
			{/*		handleCancel={setIsOpenInfoEmployer.bind(null, false)}*/}
			{/*	></NotificationEmployer>*/}
			{/*)}*/}
			<div className={styles.profile}>
				<div className={styles.mainInformation}>
					<div className={styles.mainInfomationCol}>
						<Title>{t('company')}</Title>
						<ProfileActions
							options={companies}
							onChangeCompany={onChangeCompany}
							value={activeCompany?.code}
							manager={employer?.manager}
						/>
					</div>
					<div className={styles.logoCol}>
						<p className={styles.label}>{t('logo')}:</p>
						<img
							src={
								activeCompany?.photoId
									? `${process.env.REACT_APP_API_URL}/file/notype/${activeCompany?.photoId}`
									: UploadImagePlaceholder
							}
							alt="avatar"
							className={styles.logoImage}
						/>
					</div>
				</div>
				<div className={styles.information}>
					<CompanyAccountData company={activeCompany} hideSubTitle />
					<div className={styles.employerInfo}>
						<EmployerInformation company={activeCompany} employer={employer} />
					</div>
					<div className={styles.companyInfo}>
						<InformationAboutCompany company={activeCompany} />
					</div>
				</div>
			</div>
		</>
	)
}
